export default __webpack_public_path__ + "static/media/our-partner-logo-4.96ee025e.svg";